<script setup lang="ts">
import EditableNotesField from '@/components/rc/common/EditableNotesField.vue'
import { useRepairsContext } from '@/composables/rc/drawer-context'
import { useMinerRepairActions } from '@/composables/rc/miner-repair-actions'
import { usePartDetails } from '@/composables/rc/part-details'

// Server state bindings
const { minerId, selectedPart } = useRepairsContext()
const { partId, repairNotes, movedToInventory } = usePartDetails(minerId, selectedPart)

// Server actions

const { updatePartStatusMutation } = useMinerRepairActions(minerId)

const onSavePartRepairNotes = (text: string, discardNotes: () => void) => {
  if (!partId.value) return
  updatePartStatusMutation.mutate(
    {
      part_id: partId.value,
      partName: selectedPart.value,
      repair_notes: text,
    },
    {
      onError: discardNotes,
    }
  )
}
</script>

<template>
  <div class="w-full flex flex-col gap-spacing-sm">
    <!-- Repair notes input -->
    <EditableNotesField
      title="Notes"
      :cache-value="repairNotes ?? ''"
      placeholder="Enter repair notes..."
      style="width: 100%"
      :headless="movedToInventory"
      @save="onSavePartRepairNotes"
    />
  </div>
</template>
